// import axios from "axios";
// import authHeader from "./auth-header";
// import API_BASE_ from "../config/apiConfig";

// const API_BASE = `${API_BASE_}`;
// const API_LIVE_TRAININGS = `${API_BASE}/live-trainings`;

// // ============ LECTURE ============

// /**
//  * Récupérer toutes les formations actives et approuvées (public)
//  */
// const getAllActive = async () => {
//     try {
//         const response = await axios.get(API_LIVE_TRAININGS, {
//             headers: authHeader(),
//         });
//         console.log("✅ Formations live récupérées:", response.data.length);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur récupération formations live:", error);
//         throw error;
//     }
// };

// /**
//  * Récupérer une formation par ID
//  */
// const getById = async (id) => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/${id}`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur récupération formation live:", error);
//         throw error;
//     }
// };

// /**
//  * Récupérer les formations à venir
//  */
// const getUpcoming = async () => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/upcoming`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur récupération formations à venir:", error);
//         throw error;
//     }
// };

// /**
//  * Récupérer les formations passées
//  */
// const getPast = async () => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/past`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur récupération formations passées:", error);
//         throw error;
//     }
// };

// /**
//  * Récupérer les formations par catégorie
//  */
// const getByCategory = async (categoryId) => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/category/${categoryId}`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur récupération par catégorie:", error);
//         throw error;
//     }
// };

// /**
//  * Récupérer les formations d'un modérateur
//  */
// const getByModerator = async (userId) => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/moderator?userId=${userId}`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur récupération par modérateur:", error);
//         throw error;
//     }
// };

// // ============ CRÉATION / MISE À JOUR ============

// /**
//  * ✅ Créer une formation live AVEC image (multipart)
//  */
// const createLiveTraining = async (liveTrainingData, file) => {
//     if (!liveTrainingData || !file) {
//         throw new Error("Données ou fichier manquants");
//     }

//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("liveTraining", JSON.stringify(liveTrainingData));

//     try {
//         console.log("🚀 Envoi création formation live:", liveTrainingData);
//         const response = await axios.post(
//             `${API_LIVE_TRAININGS}/create`,
//             formData,
//             {
//                 headers: {
//                     ...authHeader(),
//                     "Content-Type": "multipart/form-data",
//                 },
//             }
//         );
//         console.log("✅ Formation live créée:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur création formation live:", error.response || error.message);
//         const errorMessage = error.response?.data?.message || error.response?.data || "Erreur lors de la création";
//         throw new Error(errorMessage);
//     }
// };

// /**
//  * 🔄 Mettre à jour une formation live
//  */
// const updateLiveTraining = async (id, liveTrainingData, file) => {
//     if (!id || !liveTrainingData) {
//         throw new Error("ID ou données manquants");
//     }

//     const formData = new FormData();
//     if (file) {
//         formData.append("file", file);
//     }
//     formData.append("liveTraining", JSON.stringify(liveTrainingData));

//     try {
//         const response = await axios.put(
//             `${API_LIVE_TRAININGS}/update/${id}`,
//             formData,
//             {
//                 headers: {
//                     ...authHeader(),
//                     "Content-Type": "multipart/form-data",
//                 },
//             }
//         );
//         console.log("✅ Formation live mise à jour:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur mise à jour:", error.response || error.message);
//         throw new Error(error.response?.data || "Erreur lors de la mise à jour");
//     }
// };

// // ============ SUPPRESSION ============

// /**
//  * Suppression logique
//  */
// const softDelete = async (id) => {
//     try {
//         const response = await axios.delete(`${API_LIVE_TRAININGS}/${id}`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur suppression:", error);
//         throw error;
//     }
// };

// /**
//  * Restaurer
//  */
// const restore = async (id) => {
//     try {
//         const response = await axios.put(
//             `${API_LIVE_TRAININGS}/${id}/restore`,
//             null,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur restauration:", error);
//         throw error;
//     }
// };

// /**
//  * Suppression définitive (admin)
//  */
// const permanentlyDelete = async (id) => {
//     try {
//         const response = await axios.delete(`${API_LIVE_TRAININGS}/${id}/permanent`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur suppression définitive:", error);
//         throw error;
//     }
// };

// // ============ ADMIN ============

// const getAllForAdmin = async () => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/admin/all`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur admin all:", error);
//         throw error;
//     }
// };

// const getPending = async () => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/admin/pending`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur pending:", error);
//         throw error;
//     }
// };

// const getDeleted = async () => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/admin/deleted`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur deleted:", error);
//         throw error;
//     }
// };

// const approve = async (id) => {
//     try {
//         const response = await axios.put(
//             `${API_LIVE_TRAININGS}/admin/${id}/approve`,
//             null,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur approbation:", error);
//         throw error;
//     }
// };

// const reject = async (id) => {
//     try {
//         const response = await axios.put(
//             `${API_LIVE_TRAININGS}/admin/${id}/reject`,
//             null,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur rejet:", error);
//         throw error;
//     }
// };

// // ============ STATS ============

// const getStats = async (moderatorId = null) => {
//     try {
//         const url = moderatorId
//             ? `${API_LIVE_TRAININGS}/stats?moderatorId=${moderatorId}`
//             : `${API_LIVE_TRAININGS}/stats`;
//         const response = await axios.get(url, { headers: authHeader() });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur stats:", error);
//         throw error;
//     }
// };
// const getAllForAdminEnriched = async () => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/admin/all-enriched`, {
//             headers: authHeader(),
//         });
//         console.log("✅ Formations admin enrichies:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur admin all enriched:", error);
//         throw error;
//     }
// };

// const getPendingEnriched = async () => {
//     try {
//         const response = await axios.get(`${API_LIVE_TRAININGS}/admin/pending-enriched`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur pending enriched:", error);
//         throw error;
//     }
// };

// // ============ PAIEMENT ============

// const API_LIVE_PAYMENT = `${API_BASE}/payment/live-training`;

// /**
//  * 💳 Créer un PaymentIntent Stripe pour une formation live
//  */
// const createPaymentIntent = async (userId, liveTrainingId, currency = "usd") => {
//     try {
//         const response = await axios.post(
//             `${API_LIVE_PAYMENT}/create-auto`,
//             { userId, liveTrainingId, currency },
//             { headers: authHeader() }
//         );
//         console.log("💳 PaymentIntent créé:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur création paiement:", error);
//         throw error;
//     }
// };

// /**
//  * ✅ Confirmer un paiement (mode test)
//  */
// const confirmPayment = async (paymentIntentId) => {
//     try {
//         const response = await axios.post(
//             `${API_LIVE_PAYMENT}/confirm?paymentIntentId=${encodeURIComponent(paymentIntentId)}`,
//             null,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur confirmation paiement:", error);
//         throw error;
//     }
// };

// /**
//  * 🧪 Simuler un paiement réussi (mode test)
//  */
// const simulatePaymentSuccess = async (paymentIntentId) => {
//     try {
//         const response = await axios.post(
//             `${API_LIVE_PAYMENT}/simulate-payment-success?paymentIntentId=${encodeURIComponent(paymentIntentId)}`,
//             null,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur simulation paiement:", error);
//         throw error;
//     }
// };

// /**
//  * 📊 Vérifier le statut d'un paiement
//  */
// const getPaymentStatus = async (paymentIntentId) => {
//     try {
//         const response = await axios.get(
//             `${API_LIVE_PAYMENT}/status?paymentIntentId=${encodeURIComponent(paymentIntentId)}`,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur statut paiement:", error);
//         throw error;
//     }
// };

// /**
//  * 🔍 Vérifier si l'utilisateur a déjà acheté une formation live
//  */
// const checkPurchase = async (userId, liveTrainingId) => {
//     try {
//         const response = await axios.get(
//             `${API_LIVE_PAYMENT}/check-purchase?userId=${userId}&liveTrainingId=${liveTrainingId}`,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur check purchase:", error);
//         return { hasPurchased: false };
//     }
// };

// /**
//  * 📋 Récupérer toutes les formations live achetées par l'utilisateur
//  */
// const getMyLivePurchases = async (userId) => {
//     try {
//         const response = await axios.get(
//             `${API_LIVE_PAYMENT}/my-purchases?userId=${userId}`,
//             { headers: authHeader() }
//         );
//         console.log("📋 Mes formations live:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur mes achats live:", error);
//         throw error;
//     }
// };

// /**
//  * 👥 Récupérer les participants d'une formation live (formateur/admin)
//  */
// const getParticipants = async (liveTrainingId) => {
//     try {
//         const response = await axios.get(
//             `${API_LIVE_PAYMENT}/${liveTrainingId}/participants`,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur participants:", error);
//         throw error;
//     }
// };

// /**
//  * 📊 Compter les inscrits à une formation
//  */
// const countParticipants = async (liveTrainingId) => {
//     try {
//         const response = await axios.get(
//             `${API_LIVE_PAYMENT}/${liveTrainingId}/count-participants`,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur count:", error);
//         return { count: 0 };
//     }
// };


// // ============ MONERIS PAYMENT ============

// const API_MONERIS_PAYMENT = `${API_BASE}/payments/moneris`;

// /**
//  * 💳 Créer un ticket Moneris pour une formation live
//  * Réutilise l'endpoint existant /api/payments/moneris/create-ticket
//  */
// const createMonerisTicket = async ({ liveTraining, amount, user }) => {
//     const sanitizeDescriptor = (s) =>
//         (s || 'LIVE_TRAINING')
//             .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
//             .replace(/[^A-Za-z0-9 ]/g, '')
//             .trim().toUpperCase()
//             .slice(0, 20);

//     const payload = {
//         amount: Number(amount || liveTraining?.price || 0),
//         currency: 'CAD',
//         orderId: `LIVE-${liveTraining?.id}-${Date.now()}`,
//         description: sanitizeDescriptor(liveTraining?.title),
//         successUrl: `${window.location.origin}/payments/moneris/live-success`,
//         cancelUrl: `${window.location.origin}/payments/moneris/live-cancel`,
//         // ⭐ IMPORTANT : on passe userId mais PAS courseId 
//         // (sinon le backend pense qu'on achète un cours)
//         userId: user?.id,
//         // ❌ Pas de courseId pour les formations live
//         contactInfo: {
//             firstName: user?.firstName || user?.username || 'User',
//             lastName: user?.lastName || 'N/A',
//             email: user?.email || '',
//             phone: user?.phone || ''
//         }
//     };

//     try {
//         console.log("💳 Création ticket Moneris pour formation live:", payload);
//         const { data } = await axios.post(
//             `${API_MONERIS_PAYMENT}/create-ticket`,
//             payload,
//             { 
//                 headers: { ...authHeader(), 'Content-Type': 'application/json' }, 
//                 withCredentials: true 
//             }
//         );
//         console.log("✅ Ticket Moneris créé:", data);
//         return data;
//     } catch (error) {
//         console.error("❌ Erreur création ticket Moneris:", error);
//         throw error;
//     }
// };

// /**
//  * ✅ Vérifier et traiter le paiement Moneris pour une formation live
//  * Appelé après le retour de Moneris (success page)
//  */
// const monerisVerifyAndProcessLiveTraining = async (ticketId, userId, liveTrainingId) => {
//     try {
//         console.log("🔍 Vérification paiement Moneris formation live:", { ticketId, userId, liveTrainingId });
//         const response = await axios.post(
//             `${API_MONERIS_PAYMENT}/verify-and-process-live-training`,
//             {
//                 ticketId: ticketId,
//                 userId: parseInt(userId),
//                 liveTrainingId: parseInt(liveTrainingId)
//             },
//             {
//                 headers: {
//                     ...authHeader(),
//                     'Content-Type': 'application/json'
//                 }
//             }
//         );
//         console.log("✅ Vérification réussie:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur vérification Moneris formation live:", error);
//         throw error;
//     }
// };

// /**
//  * 🔍 Vérifier si l'utilisateur a déjà acheté la formation live (via Moneris)
//  */
// const checkLiveTrainingPurchaseMoneris = async (userId, liveTrainingId) => {
//     try {
//         const response = await axios.get(
//             `${API_MONERIS_PAYMENT}/check-live-training-purchase?userId=${userId}&liveTrainingId=${liveTrainingId}`,
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("❌ Erreur check live training:", error);
//         return { hasPurchased: false };
//     }
// };
// // ============ EXPORT ============

// const liveTrainingService = {
//     // Lecture
//     getAllActive,
//     getById,
//     getUpcoming,
//     getPast,
//     getByCategory,
//     getByModerator,

//     // CRUD
//     createLiveTraining,
//     updateLiveTraining,

//     // Suppression
//     softDelete,
//     restore,
//     permanentlyDelete,

//     // Admin
//     getAllForAdmin,
//     getPending,
//     getDeleted,
//     approve,
//     reject,

//     // Stats
//     getStats,

//       // Admin Enrichi
//     getAllForAdminEnriched,    // ⭐ AJOUTER
//     getPendingEnriched,         // ⭐ AJOUTER

// // 💳 Paiement
//     createPaymentIntent,
//     confirmPayment,
//     simulatePaymentSuccess,
//     getPaymentStatus,
//     checkPurchase,
//     getMyLivePurchases,
//     getParticipants,
//     countParticipants,


//       // 💳 Moneris Payment
//     createMonerisTicket,
//     monerisVerifyAndProcessLiveTraining,
//     checkLiveTrainingPurchaseMoneris,

// };

// export default liveTrainingService;


import axios from "axios";
import authHeader from "./auth-header";
import API_BASE_ from "../config/apiConfig";

const API_BASE = `${API_BASE_}`;
const API_LIVE_TRAININGS = `${API_BASE}/live-trainings`;

// ============ LECTURE ============

/**
 * Récupérer toutes les formations actives et approuvées (public)
 */
const getAllActive = async () => {
    try {
        const response = await axios.get(API_LIVE_TRAININGS, {
            headers: authHeader(),
        });
        console.log("✅ Formations live récupérées:", response.data.length);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur récupération formations live:", error);
        throw error;
    }
};

/**
 * Récupérer une formation par ID
 */
const getById = async (id) => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur récupération formation live:", error);
        throw error;
    }
};

/**
 * Récupérer les formations à venir
 */
const getUpcoming = async () => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/upcoming`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur récupération formations à venir:", error);
        throw error;
    }
};

/**
 * Récupérer les formations passées
 */
const getPast = async () => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/past`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur récupération formations passées:", error);
        throw error;
    }
};

/**
 * Récupérer les formations par catégorie
 */
const getByCategory = async (categoryId) => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/category/${categoryId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur récupération par catégorie:", error);
        throw error;
    }
};

/**
 * Récupérer les formations d'un modérateur
 */
const getByModerator = async (userId) => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/moderator?userId=${userId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur récupération par modérateur:", error);
        throw error;
    }
};

// ============================================================
// ✅ NOUVEAU : MÉTHODES LIGHT POUR SÉLECTEURS (ultra-rapide)
//    Retourne UNIQUEMENT { id, title } — pas d'images !
//    Gain de performance massif (~95%)
// ============================================================

/**
 * ⚡ Liste light de TOUTES les formations (admin)
 */
const getAllLite = async () => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/lite/all`, {
            headers: authHeader(),
        });
        console.log("⚡ Formations light (admin):", response.data.length);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur getAllLite:", error);
        throw error;
    }
};

/**
 * ⚡ Liste light des formations d'un modérateur
 */
const getByModeratorLite = async (userId) => {
    try {
        const response = await axios.get(
            `${API_LIVE_TRAININGS}/lite/moderator?userId=${userId}`,
            { headers: authHeader() }
        );
        console.log("⚡ Formations light (modérateur):", response.data.length);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur getByModeratorLite:", error);
        throw error;
    }
};

// ============ CRÉATION / MISE À JOUR ============

/**
 * ✅ Créer une formation live AVEC image (multipart)
 */
const createLiveTraining = async (liveTrainingData, file) => {
    if (!liveTrainingData || !file) {
        throw new Error("Données ou fichier manquants");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("liveTraining", JSON.stringify(liveTrainingData));

    try {
        console.log("🚀 Envoi création formation live:", liveTrainingData);
        const response = await axios.post(
            `${API_LIVE_TRAININGS}/create`,
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        console.log("✅ Formation live créée:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur création formation live:", error.response || error.message);
        const errorMessage = error.response?.data?.message || error.response?.data || "Erreur lors de la création";
        throw new Error(errorMessage);
    }
};

/**
 * 🔄 Mettre à jour une formation live
 */
const updateLiveTraining = async (id, liveTrainingData, file) => {
    if (!id || !liveTrainingData) {
        throw new Error("ID ou données manquants");
    }

    const formData = new FormData();
    if (file) {
        formData.append("file", file);
    }
    formData.append("liveTraining", JSON.stringify(liveTrainingData));

    try {
        const response = await axios.put(
            `${API_LIVE_TRAININGS}/update/${id}`,
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        console.log("✅ Formation live mise à jour:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur mise à jour:", error.response || error.message);
        throw new Error(error.response?.data || "Erreur lors de la mise à jour");
    }
};

// ============ SUPPRESSION ============

const softDelete = async (id) => {
    try {
        const response = await axios.delete(`${API_LIVE_TRAININGS}/${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur suppression:", error);
        throw error;
    }
};

const restore = async (id) => {
    try {
        const response = await axios.put(
            `${API_LIVE_TRAININGS}/${id}/restore`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur restauration:", error);
        throw error;
    }
};

const permanentlyDelete = async (id) => {
    try {
        const response = await axios.delete(`${API_LIVE_TRAININGS}/${id}/permanent`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur suppression définitive:", error);
        throw error;
    }
};

// ============ ADMIN ============

const getAllForAdmin = async () => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/admin/all`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur admin all:", error);
        throw error;
    }
};

const getPending = async () => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/admin/pending`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur pending:", error);
        throw error;
    }
};

const getDeleted = async () => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/admin/deleted`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur deleted:", error);
        throw error;
    }
};

const approve = async (id) => {
    try {
        const response = await axios.put(
            `${API_LIVE_TRAININGS}/admin/${id}/approve`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur approbation:", error);
        throw error;
    }
};

const reject = async (id) => {
    try {
        const response = await axios.put(
            `${API_LIVE_TRAININGS}/admin/${id}/reject`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur rejet:", error);
        throw error;
    }
};

// ============ STATS ============

const getStats = async (moderatorId = null) => {
    try {
        const url = moderatorId
            ? `${API_LIVE_TRAININGS}/stats?moderatorId=${moderatorId}`
            : `${API_LIVE_TRAININGS}/stats`;
        const response = await axios.get(url, { headers: authHeader() });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur stats:", error);
        throw error;
    }
};

const getAllForAdminEnriched = async () => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/admin/all-enriched`, {
            headers: authHeader(),
        });
        console.log("✅ Formations admin enrichies:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur admin all enriched:", error);
        throw error;
    }
};

const getPendingEnriched = async () => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/admin/pending-enriched`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur pending enriched:", error);
        throw error;
    }
};


// ============ BACKFILL MINIATURES ============

/**
 * 🔧 Régénère les miniatures manquantes pour les anciennes formations
 *    (à exécuter une seule fois)
 */
const backfillThumbnails = async () => {
    try {
        const response = await axios.post(
            `${API_LIVE_TRAININGS}/admin/backfill-thumbnails`,
            null,
            { headers: authHeader() }
        );
        console.log("🔧 Backfill miniatures terminé:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur backfill miniatures:", error);
        throw error;
    }
};

// ============ PAIEMENT ============

const API_LIVE_PAYMENT = `${API_BASE}/payment/live-training`;

const createPaymentIntent = async (userId, liveTrainingId, currency = "usd") => {
    try {
        const response = await axios.post(
            `${API_LIVE_PAYMENT}/create-auto`,
            { userId, liveTrainingId, currency },
            { headers: authHeader() }
        );
        console.log("💳 PaymentIntent créé:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur création paiement:", error);
        throw error;
    }
};

const confirmPayment = async (paymentIntentId) => {
    try {
        const response = await axios.post(
            `${API_LIVE_PAYMENT}/confirm?paymentIntentId=${encodeURIComponent(paymentIntentId)}`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur confirmation paiement:", error);
        throw error;
    }
};

const simulatePaymentSuccess = async (paymentIntentId) => {
    try {
        const response = await axios.post(
            `${API_LIVE_PAYMENT}/simulate-payment-success?paymentIntentId=${encodeURIComponent(paymentIntentId)}`,
            null,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur simulation paiement:", error);
        throw error;
    }
};

const getPaymentStatus = async (paymentIntentId) => {
    try {
        const response = await axios.get(
            `${API_LIVE_PAYMENT}/status?paymentIntentId=${encodeURIComponent(paymentIntentId)}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur statut paiement:", error);
        throw error;
    }
};

const checkPurchase = async (userId, liveTrainingId) => {
    try {
        const response = await axios.get(
            `${API_LIVE_PAYMENT}/check-purchase?userId=${userId}&liveTrainingId=${liveTrainingId}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur check purchase:", error);
        return { hasPurchased: false };
    }
};

const getMyLivePurchases = async (userId) => {
    try {
        const response = await axios.get(
            `${API_LIVE_PAYMENT}/my-purchases?userId=${userId}`,
            { headers: authHeader() }
        );
        console.log("📋 Mes formations live:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur mes achats live:", error);
        throw error;
    }
};

const getParticipants = async (liveTrainingId) => {
    try {
        const response = await axios.get(
            `${API_LIVE_PAYMENT}/${liveTrainingId}/participants`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur participants:", error);
        throw error;
    }
};

const countParticipants = async (liveTrainingId) => {
    try {
        const response = await axios.get(
            `${API_LIVE_PAYMENT}/${liveTrainingId}/count-participants`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur count:", error);
        return { count: 0 };
    }
};

// ============ MONERIS PAYMENT ============

const API_MONERIS_PAYMENT = `${API_BASE}/payments/moneris`;

const createMonerisTicket = async ({ liveTraining, amount, user }) => {
    const sanitizeDescriptor = (s) =>
        (s || 'LIVE_TRAINING')
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/[^A-Za-z0-9 ]/g, '')
            .trim().toUpperCase()
            .slice(0, 20);

    const payload = {
        amount: Number(amount || liveTraining?.price || 0),
        currency: 'CAD',
        orderId: `LIVE-${liveTraining?.id}-${Date.now()}`,
        description: sanitizeDescriptor(liveTraining?.title),
        successUrl: `${window.location.origin}/payments/moneris/live-success`,
        cancelUrl: `${window.location.origin}/payments/moneris/live-cancel`,
        userId: user?.id,
        contactInfo: {
            firstName: user?.firstName || user?.username || 'User',
            lastName: user?.lastName || 'N/A',
            email: user?.email || '',
            phone: user?.phone || ''
        }
    };

    try {
        console.log("💳 Création ticket Moneris pour formation live:", payload);
        const { data } = await axios.post(
            `${API_MONERIS_PAYMENT}/create-ticket`,
            payload,
            {
                headers: { ...authHeader(), 'Content-Type': 'application/json' },
                withCredentials: true
            }
        );
        console.log("✅ Ticket Moneris créé:", data);
        return data;
    } catch (error) {
        console.error("❌ Erreur création ticket Moneris:", error);
        throw error;
    }
};

const monerisVerifyAndProcessLiveTraining = async (ticketId, userId, liveTrainingId) => {
    try {
        console.log("🔍 Vérification paiement Moneris formation live:", { ticketId, userId, liveTrainingId });
        const response = await axios.post(
            `${API_MONERIS_PAYMENT}/verify-and-process-live-training`,
            {
                ticketId: ticketId,
                userId: parseInt(userId),
                liveTrainingId: parseInt(liveTrainingId)
            },
            {
                headers: {
                    ...authHeader(),
                    'Content-Type': 'application/json'
                }
            }
        );
        console.log("✅ Vérification réussie:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur vérification Moneris formation live:", error);
        throw error;
    }
};

const checkLiveTrainingPurchaseMoneris = async (userId, liveTrainingId) => {
    try {
        const response = await axios.get(
            `${API_MONERIS_PAYMENT}/check-live-training-purchase?userId=${userId}&liveTrainingId=${liveTrainingId}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Erreur check live training:", error);
        return { hasPurchased: false };
    }
};

/**
 * ⚡ Liste admin LÉGÈRE (sans image, juste thumbnail) — rapide
 */
const getAllAdminLight = async () => {
    try {
        const response = await axios.get(`${API_LIVE_TRAININGS}/admin/all-light`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur getAllAdminLight:", error);
        throw error;
    }
};

// ============ EXPORT ============

const liveTrainingService = {
    // Lecture
    getAllActive,
    getById,
    getUpcoming,
    getPast,
    getByCategory,
    getByModerator,

    // ⚡ NOUVEAU : Light (sélecteurs)
    getAllLite,
    getByModeratorLite,

    // CRUD
    createLiveTraining,
    updateLiveTraining,

    // Suppression
    softDelete,
    restore,
    permanentlyDelete,

    // Admin
    getAllForAdmin,
    getPending,
    getDeleted,
    approve,
    reject,

    // Stats
    getStats,

    // Admin Enrichi
    getAllForAdminEnriched,
    getPendingEnriched,
 // 🔧 Backfill miniatures
    backfillThumbnails,
    // 💳 Paiement
    createPaymentIntent,
    confirmPayment,
    simulatePaymentSuccess,
    getPaymentStatus,
    checkPurchase,
    getMyLivePurchases,
    getParticipants,
    countParticipants,

    // 💳 Moneris Payment
    createMonerisTicket,
    monerisVerifyAndProcessLiveTraining,
    checkLiveTrainingPurchaseMoneris,

        getAllAdminLight,

};

export default liveTrainingService;